import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, BarChart2, Settings } from 'lucide-react';

export function MobileBottomNav() {
  const location = useLocation();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Home', path: '/' },
    { icon: Users, label: 'Alunos', path: '/students' },
    { icon: BarChart2, label: 'Relatórios', path: '/open-rate-report' },
    { icon: Settings, label: 'Config', path: '/settings' },
  ];

  return (
    <div className="bg-[#1A1D23] border-t border-[#2A2D35] fixed bottom-0 left-0 right-0 z-50">
      <nav className="flex justify-around">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center py-3 px-4 ${
                isActive ? 'text-[#268c73]' : 'text-gray-400'
              }`}
            >
              <Icon className="w-6 h-6" />
              <span className="text-xs mt-1">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}